export const CAMPAIGN_PLAN_EXPIRED_MESSAGE = 'You cannot access this campaign plan as it is unavailable.';
